import type { ISerialize } from '@/objects/ISerialize';
import { TimeSpan, type ITimeSpan } from '@/objects/TimeSpan';

export class TimepenaltyRequest implements ISerialize {
    public ContestantID: number;

    public EventID: number;

    public Km: number | null;

    public Penalty: ITimeSpan;

    public RaceContestantID: number;

    public RaceID: number;

    public Reason: string | null;

    public ReasonID: number;

    public TUID: string | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        ContestantID?: number;
        EventID?: number;
        Km?: number | null;
        Penalty?: ITimeSpan;
        RaceContestantID?: number;
        RaceID?: number;
        Reason?: string | null;
        ReasonID?: number;
        TUID?: string | null;
    }) {
        this.ContestantID = values.ContestantID ?? 0;

        this.EventID = values.EventID ?? 0;

        this.Km = values.Km ?? null;

        this.Penalty = values.Penalty ?? TimeSpan.Empty();

        this.RaceContestantID = values.RaceContestantID ?? 0;

        this.RaceID = values.RaceID ?? 0;

        this.Reason = values.Reason ?? null;

        this.ReasonID = values.ReasonID ?? 0;

        this.TUID = values.TUID ?? null;
    }

    public serialize(): string {
        return (
            '{' +
            `"ContestantID": ${JSON.stringify(this.ContestantID)}` +
            ',' +
            `"EventID": ${JSON.stringify(this.EventID)}` +
            ',' +
            `"Km": ${JSON.stringify(this.Km)}` +
            ',' +
            `"Penalty": ${'"' + this.Penalty?.serialize() + '"'}` +
            ',' +
            `"RaceContestantID": ${JSON.stringify(this.RaceContestantID)}` +
            ',' +
            `"RaceID": ${JSON.stringify(this.RaceID)}` +
            ',' +
            `"Reason": ${JSON.stringify(this.Reason)}` +
            ',' +
            `"ReasonID": ${JSON.stringify(this.ReasonID)}` +
            ',' +
            `"TUID": ${JSON.stringify(this.TUID)}` +
            '}'
        );
    }

    /**
     * Creates an instance of TimepenaltyRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        ContestantID?: number;
        EventID?: number;
        Km?: number | null;
        Penalty?: ITimeSpan;
        RaceContestantID?: number;
        RaceID?: number;
        Reason?: string | null;
        ReasonID?: number;
        TUID?: string | null;
    }): TimepenaltyRequest {
        return new TimepenaltyRequest(values);
    }

    public static _FromServerJson(json: any): TimepenaltyRequest {
        return new TimepenaltyRequest({
            ContestantID: json.ContestantID,
            EventID: json.EventID,
            Km: json.Km ?? null,
            Penalty: json.Penalty ? TimeSpan.FromTimeString(json.Penalty) : TimeSpan.Empty(),
            RaceContestantID: json.RaceContestantID,
            RaceID: json.RaceID,
            Reason: json.Reason ?? '',
            ReasonID: json.ReasonID,
            TUID: json.TUID ?? '',
        });
    }

    /**
     * Creates an instance of TimepenaltyRequest from another instance of TimepenaltyRequest.
     * @param other The TimepenaltyRequest you want to clone
     * @returns A cloned TimepenaltyRequest
     */
    public static FromOther(other: TimepenaltyRequest): TimepenaltyRequest {
        return TimepenaltyRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return TimepenaltyRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'TimepenaltyRequest';
}
